import React from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

function Contact() {
  const { t } = useTranslation();
  
  const contacts = [
    {
      name: t('team.piotr.name'),
      email: 'piotr.bombol@ourobor.co',
      phone: '+48 602 407 789'
    },
    {
      name: t('team.tomasz.name'),
      email: 'tomasz.kerber@ourobor.co',
      phone: '+48 609 199 316'
    }
  ];

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    message: ''
  });
  const [status, setStatus] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('sending');

    try {
      const response = await fetch('https://srv71273.seohost.com.pl/mailer.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });

      if (response.ok) {
        setStatus('success');
        setFormData({ name: '', email: '', company: '', message: '' });
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };

  return (
    <section className="section contact-section" id="contact">
      <div className="container">
        <div className="requirements">
          <h2 className="cta-title">{t('contact.title')} <span className="cta-subtitle">{t('contact.subtitle')}</span></h2>
          <p className="cta-message">{t('contact.message')}</p>

          <h4>{t('contact.requirementsTitle')}</h4>
          <ul>
            <li>{t('contact.req1')}</li>
            <li>{t('contact.req2')}</li>
            <li>{t('contact.req3')}</li>
          </ul>
          <div className="availability-badge">{t('contact.availability')}</div>
          <p className="contact-call-directly"><a href="tel:+48602407789">{t('contact.callDirectly')} <span
              className="teal-text"> + 48 602 407 789</span></a></p>
        </div>

        <div className="cta-divider">{t('form.sendUsMessage')}</div>

        <div className="contact-form">
          <form onSubmit={handleSubmit}>
            <div className="contact-form-name-email">
              <div>
                <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder={t('form.name')}
                    required
                />
              </div>

              <div>
                <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder={t('form.email')}
                    required
                />
              </div>
            </div>

            <div>
              <input
                  type="text"
                  id="company"
                  name="company"
                  value={formData.company}
                  onChange={handleChange}
                  placeholder={t('form.company')}
              />
            </div>

            <div>
              <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  rows={5}
                  placeholder={t('form.message')}
                  required
              />
            </div>

            <button type="submit" disabled={status === 'sending'}>
              {status === 'sending' ? t('form.sending') : t('form.submit')}
            </button>

            {status === 'success' && <p>{t('form.success')}</p>}
            {status === 'error' && <p>{t('form.error')}</p>}
          </form>
        </div>

        <div className="contact-cards">
          {contacts.map((contact) => (
              <div className="contact-card" key={contact.name}>
                <h4 className="contact-name">{contact.name}</h4>
                <a href={`mailto:${contact.email}`} className="contact-email">{contact.email}</a>
                <a href={`tel:${contact.phone.replace(/\s/g, '')}`} className="contact-phone">{contact.phone}</a>
              </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Contact;
